import {Station} from './station';

export const STATIONS: Station[] = [
  {
    label: 'wladyslawowo',
    name: 'LB-480_WLAD_BLUE_1'
  },
  {
    label: 'sopot',
    name: 'LB-480_SOPOT_BLUE'
  },
  {
    label: 'rewa',
    name: 'LB-480_REWA_BLUE'
  }
];



// WEBPACK FOOTER //
// ./src/app/station/mock-stations.ts